import { ChatModel } from '@/models/chat.model'
import { differenceInMilliseconds } from 'date-fns'
import { all, put, spawn } from 'redux-saga/effects'
import { clearActiveChatAction } from '../../actions'
import { cancelChatAction } from '../../handles/cancelChatAction'
import { Chat } from '../../types'
import { onEndServiceHook } from '../closeChatSaga/http/onEndServiceHook'
import { findUserById, FindUserByIdResponse, updateOnFirebase } from '../_http/user'
import { update } from '../_http/chat'

export function* cancelChatSaga(action: ReturnType<typeof cancelChatAction.request>) {
  const { chat, userAuthenticatedId, companyId } = action.payload
  try {
    const updatedOperators = chat.operators.filter(operator => operator.id !== userAuthenticatedId)
    const updatedOperatorsId = chat.operatorsId.filter(operatorId => operatorId !== userAuthenticatedId)

    updateChatDurationsOnCancel(chat, userAuthenticatedId)
    const updatedData: Partial<Chat> = {
      status: updatedOperators.length > 0 ? 'in_progress' : 'open',
      operators: updatedOperators,
      operatorsId: updatedOperatorsId,
      category: null,
      startDate: chat.startDate,
      endDate: chat.endDate,
      durations: chat.durations,
      fixedBy: null
    }
    updatedData.endDate = new Date().getTime()
    updatedData.duration = differenceInMilliseconds(new Date(updatedData.endDate), new Date(updatedData.startDate))
    const { user }: FindUserByIdResponse = yield findUserById(userAuthenticatedId)
    const updatedAttendFor = user?.attendFor?.filter(campaignId => campaignId !== chat.campaignId) || []

    yield put(cancelChatAction.success({ chatId: chat.id }))
    yield all([
      update(chat.id, { ...updatedData, updatedAt: updatedData.endDate }),
      updateOnFirebase(user.id, { attendFor: updatedAttendFor })
    ])
    yield put(clearActiveChatAction())
    yield spawn(onEndServiceHook, { ...chat, ...updatedData }, companyId)
  } catch (error) {
    console.error('Error when ending chat:', error)
    yield put(cancelChatAction.failure(error))
  }
}

function updateChatDurationsOnCancel(activeChat: ChatModel, operatorId: string) {
  const operatorDuration = findOperatorDuration(activeChat, operatorId)
  if (operatorDuration) {
    const currentPeriod = operatorDuration.periods.at(-1)
    if (currentPeriod && !currentPeriod?.endTime) {
      currentPeriod.endTime = Date.now()
    }
  }
}

function findOperatorDuration(activeChat: ChatModel, operatorId: string) {
  const durations = activeChat?.durations ?? []
  const operatorDuration = durations.find(duration => duration.operatorId === operatorId)
  return operatorDuration
}
